/**
 * AgentDetailLive.jsx
 * Block 3 — Aktueller Stand
 *
 * Heute: Offen + Wartend + Abgeschlossen (live, wie bisher)
 * Woche / Monat / Jahr:
 *   - Tickets gesamt
 *   - Abgeschlossen
 *   - Ø Bearbeitungszeit (Business Hours)
 */

import React from 'react';

export default function AgentDetailLive({ data, loading }) {
  if (loading) {
    return (
      <div className="live-grid">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="live-card live-card--skeleton" />
        ))}
      </div>
    );
  }

  if (!data) return null;

  const heute = data.heute || {};
  const woche = data.woche || {};
  const monat = data.monat || {};
  const jahr  = data.jahr  || {};

  return (
    <div className="live-grid">

      {/* Heute — Offen / Wartend / Abgeschlossen (wie vorher) */}
      <div className="live-card">
        <span className="live-card__label">Heute</span>
        <div className="live-card__stats">
          <div className="live-stat live-stat--offen">
            <span className="live-stat__val">{heute.offen ?? '–'}</span>
            <span className="live-stat__key">Offen</span>
          </div>
          <div className="live-stat live-stat--wartend">
            <span className="live-stat__val">{heute.wartend ?? '–'}</span>
            <span className="live-stat__key">Wartend</span>
          </div>
          <div className="live-stat live-stat--geloest">
            <span className="live-stat__val">{heute.abgeschlossen ?? '–'}</span>
            <span className="live-stat__key">Abgeschlossen</span>
          </div>
        </div>
      </div>

      {/* Woche / Monat / Jahr — Gesamt + Abgeschlossen + Ø Bearbeitung */}
      {[
        { key: 'woche', label: 'Diese Woche',  z: woche },
        { key: 'monat', label: 'Dieser Monat', z: monat },
        { key: 'jahr',  label: 'Dieses Jahr',  z: jahr  },
      ].map(({ key, label, z }) => (
        <div key={key} className="live-card">
          <span className="live-card__label">{label}</span>
          <div className="live-card__metrics">
            <div className="live-metric">
              <span className="live-metric__val">{z.gesamt ?? '–'}</span>
              <span className="live-metric__key">Gesamt</span>
            </div>
            <div className="live-metric">
              <span className="live-metric__val live-metric__val--green">
                {z.abgeschlossen ?? '–'}
              </span>
              <span className="live-metric__key">Abgeschlossen</span>
            </div>
            <div className="live-metric">
              <span className="live-metric__val">
                {z.bearbeitungAvgFormatiert ?? '–'}
              </span>
              <span className="live-metric__key">Ø Bearbeitung</span>
            </div>
          </div>
        </div>
      ))}

    </div>
  );
}
